import { NotificationRow } from "./NotificationRow";
import type { INotification } from "Common/Interfaces";

interface IVirtuosoItemContentProps {
  index: number;
  allItems: INotification[];
  onNotificationClick: (notification: INotification, openDetail?: boolean) => void;
  onDismiss: (e: React.MouseEvent, notificationId: string) => void;
  formatRelativeTime: (isoString: string) => string;
  newlyArrivedIds: Set<string>;
  exitingIds: Set<string>;
  onRowExited: (notificationId: string) => void;
}

export const VirtuosoItemContent = (props: IVirtuosoItemContentProps) => {
  const { index, allItems, onNotificationClick, onDismiss, formatRelativeTime, newlyArrivedIds, exitingIds, onRowExited } = props;
  const notification = allItems[index];
  if (!notification) return null;

  const isNew = newlyArrivedIds.has(notification.id);
  const isExiting = exitingIds.has(notification.id);

  return (
    <NotificationRow
      notification={notification}
      onNotificationClick={onNotificationClick}
      onDismiss={onDismiss}
      formatRelativeTime={formatRelativeTime}
      isNew={isNew}
      isExiting={isExiting}
      onExited={() => onRowExited(notification.id)}
    />
  );
};
